import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Cúram by Merative™ enablement materials provide deep dive presentations on new features and changes in each release.`}</p>
    <p>{`As of July 23rd, 2026, all new release documentation will be published alongside their respective release packages through our `}<a parentName="p" {...{
        "href": "https://merative.my.site.com/mysupport/s/"
      }}>{`support portal`}</a>{` `}</p>
    <p>{`In addition to new releases, Cúram 8.2.2.0 (released July 3rd, 2026) and Cúram Action View 1.0.0 (released June 25th, 2026) documentation will also be available via our support portal for download.`}</p>
    <h3>{`For any other documentation referenced on this page, please contact `}<a parentName="h3" {...{
        "href": "https://merative.my.site.com/mysupport/s/"
      }}>{`Merative Support`}</a></h3>
    <h2>{`Cúram Action View enablement`}</h2>
    <ul>
      <li parentName="ul">{`Cúram Action View Implementation Guide`}</li>
    </ul>
    <h2>{`8.2.2.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Citizen Engagement Enhancements 8.2.2.0`}</li>
      <li parentName="ul">{`Cúram Enhancements 8.2.2.0`}</li>
    </ul>
    <h2>{`HR1 Medicaid Community Engagement Cartridge enablement​`}</h2>
    <ul>
      <li parentName="ul">{`HR1 Medicaid Community Engagement Cartridge 1.1.0 `}</li>
    </ul>
    <h2>{`8.2.1.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Citizen Engagement Enhancements 8.2.1.0`}</li>
      <li parentName="ul">{`Cúram Enhancements 8.2.1.0`}</li>
    </ul>
    <h2>{`8.2.0.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Citizen Engagement Enhancements 8.2.0.0`}</li>
      <li parentName="ul">{`Cúram Enhancements 8.2.0.0`}</li>
    </ul>
    <h2>{`8.1.3.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Citizen Engagement Enhancements 8.1.3.0`}</li>
      <li parentName="ul">{`Technical Enhancements 8.1.3.0`}</li>
    </ul>
    <h2>{`8.1.2.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Citizen Engagement Enhancements 8.1.2.0`}</li>
      <li parentName="ul">{`Technical Enhancements 8.1.2.0`}</li>
    </ul>
    <h2>{`8.1.1.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Person Evidence Management Enablement`}</li>
    </ul>
    <h2>{`8.1.0.0 enablement`}</h2>
    <ul>
      <li parentName="ul">{`Technical Enhancements 8.1.0.0`}</li>
    </ul>
    <h2>{`8.0.3.0 enablement`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      